export default "__VITE_ASSET__49a3e1f6__"